export default __webpack_public_path__ + "static/media/menu.e8db7520.svg";